<template>
  <v-container v-if="busy === false"
               class="frame-container"
               fluid>
    <iframe v-if="canUseMetabase && url && frame"
            :src="url"
            width="100%"
            height="100%">
    </iframe>
    <v-alert v-else
             type="error">
      You do not have access to the reports and dashboards.
    </v-alert>
  </v-container>
</template>
<style>
.frame-container {
  width: 100%;
  height: 100%;
}
.pre {
  word-break: break-all;
  width: 100%;
  padding: 10px 0;
}

iframe {
  border: none;
  height: 100%;
  width: 100%;
}
</style>
<script>
import {mapGetters} from 'vuex';
import metabaseService from '../../services/metabaseService';


export default {
  data() {
    return {
      busy: false,
      frame: false,
      jwt: null,
      metabaseUser: null,
      secretKey: null,
      url: null,
    }
  },
  computed: {
    ...mapGetters([
      'canUseMetabase',
    ])
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.busy = true;
      metabaseService.getAuthorizationURL()
        .then(data => {
          //this.jwt = data.jwt;
          //this.metabaseUser = data.user;
          //this.secretKey = data.secret_key;
          this.url = data.url;
          this.frame = true;
        })
        .catch(() => {})
        .finally(() => {
          this.busy = false;
        })
    }
  }
}
</script>
